import Entity from './entity';
export default class Product extends Entity<number> {

}
